import React from "react";
import { BASE_COLUMN_TYPES, BaseColumnType } from "../../columns/config/types";
import { ReportColumnConfigBase } from "../../columns/config/ReportColumnConfig";
import { getAbsoluteUrl } from "../../../../utils";

const CustomerPoColumn: ReportColumnConfigBase<typeof BASE_COLUMN_TYPES.Link> = {
  header: "Customer PO",
  type: BASE_COLUMN_TYPES.Link,
  fields: ["customer_po", "order_id"],
  accessorKey: "order_id",
  canSort: true,
  orderByField: "customer_po",
  width: 160,
  dataTransform: ({ customer_po, order_id }) => ({
    href: order_id
      ? getAbsoluteUrl(`public_order.php?order_id=${order_id}`)
      : null,
    text: customer_po,
  }),
};

const DateColumn: ReportColumnConfigBase<typeof BASE_COLUMN_TYPES.Date> = {
  header: "Date",
  type: BASE_COLUMN_TYPES.Date,
  fields: ["date_invoiced"],
  accessorKey: "date_invoiced",
  canSort: true,
  orderByField: "date_invoiced",
  width: 120,
};

const textColumn = (
  header: React.ReactNode,
  field: string,
  width: number,
): ReportColumnConfigBase<typeof BASE_COLUMN_TYPES.Text> => ({
  header,
  type: BASE_COLUMN_TYPES.Text,
  fields: [field],
  accessorKey: field,
  canSort: true,
  orderByField: field,
  width,
});

const moneyColumn = (
  header: React.ReactNode,
  field: string,
  width: number,
): ReportColumnConfigBase<typeof BASE_COLUMN_TYPES.Money> => ({
  header,
  type: BASE_COLUMN_TYPES.Money,
  fields: [field],
  accessorKey: field,
  canSort: true,
  orderByField: field,
  width,
  moneyOptions: { decimalPlaces: 2 },
  // The endpoint carries no currency, so MoneyCell's formatter falls back to USD.
  dataTransform: (data) => ({ amount: data[field], currency_id: undefined }),
});

export const Columns: ReportColumnConfigBase<BaseColumnType>[] = [
  textColumn(<>Reference</>, "pod_invoice_id", 160),
  DateColumn,
  textColumn("Client", "client_name", 180),
  textColumn("Shop", "shop_name", 180),
  textColumn("Division", "division_name", 180),
  CustomerPoColumn,
  textColumn(<>Supplier&nbsp;Order</>, "supplier_order_id", 160),
  moneyColumn(<>Invoice&nbsp;Total</>, "total", 130),
  moneyColumn(<>Item&nbsp;Cost</>, "item_cost", 130),
  moneyColumn(<>Pick&nbsp;and&nbsp;Pack</>, "pick_and_pack", 140),
  moneyColumn("Shipping", "shipping", 120),
];
